<template>
    <div v-if="!isShowFullImage" class="pb-12">
        <TopBarDetail
            :isShowBack="true"
            :isShowFavorite="true"
            :isShowShare="true"
            @clickBack="clickBack()"
        ></TopBarDetail>
        <div class="px-4">
            <Picture :campaign="campaign"></Picture>
        </div>
        <div class="px-4 rounded-xl relative">
            <div class="bg-a-blue-0069a8 p-2 absolute right-7 top-2 rounded-full" @click="clickShowFullImage()">
                <img class="w-4 h-auto" src="@/assets/icon/ic-search.png" alt="" />
            </div>
            <img class="rounded-xl" :src="getImagePath()" alt="" />
        </div>
    </div>
    <div v-else>
        <TopBarDetail
            :isShowBack="true"
            :isShowFavorite="false"
            :isShowShare="false"
            @click="clickCloseImage()"
        ></TopBarDetail>
        <div class="flex bg-black h-screen">
            <img class="image-full" :src="getImagePath()" alt="" />
        </div>
    </div>
</template>
<script>
//component
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';
import Picture from '../component/Picture.vue';
import ConfigManager from '@/config/ConfigManager.js';
export default {
    name:"typeevents",
    props: {
        campaign: Object,
    },
    components: {
        Picture,
        TopBarDetail
    },
    data: function () {
        return {
            isShowFullImage: false,
        }
    },
    methods: {
        getImagePath: function () {
            let id = this.campaign.id //470236;
            let time = new Date().getTime();
            let imageUrl = ConfigManager.getBlobUrl()+"/spluscampaign/"+id+".jpg"+"?time="+time;
            return imageUrl;
        },
        clickShowFullImage: function () {
            this.tracking.event('news', 'click_open_image', this.campaign.id);
            this.isShowFullImage = true;
        },
        clickCloseImage: function () {
            this.isShowFullImage = false;
        },
        clickBack: function() {
            this.$emit('clickBack');
        },
    }
}
</script>
<style lang="scss" scoped>
    .image-full {
        // max-height: 400px;
        width: 100%;
        margin: auto;
    }
</style>
